import {
  AnimationClassNames,
  mergeStyles,
  getTheme,
} from "@fluentui/style-utilities";

import { initializeIcons } from "@fluentui/font-icons-mdl2";

import { IButtonStyles } from "@fluentui/react/lib/Button";
import { IIconProps } from "@fluentui/react";

import { PrimaryButton } from "@fluentui/react/lib/Button";

import {
  PersonaSize,
  PersonaPresence,
  IPersonaSharedProps,
  Persona,
} from "@fluentui/react/lib/Persona";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../../auth/context/auth-context";
import { ConfigHelper } from "../../utils/helpers/configHelper";
import { PersonaImageUrl } from "../../utils/helpers/helpers";
import Logout from "../logout/logout";

initializeIcons();

const emojiIcon: IIconProps = { iconName: "WaffleOffice365" };
const LightbulbIcon: IIconProps = { iconName: "Lightbulb" };
const notificationIcon: IIconProps = { iconName: "Ringer" };
const SettingsIcon: IIconProps = { iconName: "Settings" };

const butonLeftStyles: IButtonStyles = {
  icon: {
    fontSize: "24px",
  },
};

const examplePersona: IPersonaSharedProps = {
  imageUrl: PersonaImageUrl,
  imageInitials: "US",
  text: "Annie Lindqvist",
  secondaryText: "Software Engineer",
  tertiaryText: "In a meeting",
  optionalText: "Available at 4:00pm",
  // showSecondaryText: true,
};
const lockIcon: IIconProps = { iconName: "Lock" };

const Navbar = () => {
  const { signout, access } = useContext(AuthContext);
  const navigate = useNavigate();
  const _handleSignout = () => {
    // signout(() => navigate('/ssoma/login', { replace: true }))
    window.sessionStorage.clear();
    signout(() => {
      navigate(`${ConfigHelper.urlLogin()}`, { replace: true });
    });
  };
  return (
    <div>
      <div className={navHeader}>
        <div className={navHeaderLeft}>
          <PrimaryButton iconProps={emojiIcon} className={btnClass} />
        </div>
        <div className={navHeaderCenter}>SSOMA</div>
        <div className={navHeaderRight}>
          {/* <PrimaryButton iconProps={emojiIcon} className={btnClass} /> */}
          <PrimaryButton iconProps={notificationIcon} className={btnClass} />
          <PrimaryButton iconProps={LightbulbIcon} className={btnClass} />
          <PrimaryButton iconProps={SettingsIcon} className={btnClass} />
          <Logout
            userName={access ? access.email : ""}
            email={access ? access.email : ""}
            handleSignout={_handleSignout}
            linkPerfil="/asistencia/perfilUsuario"
          />
          {/* <PrimaryButton iconProps={lockIcon} ariaLabel='Signout' title='Signout' className={btnClass} onClick={_handleSignout} /> */}
          {/* <PrimaryButton
            className={btnClass}
            styles={butonLeftStyles}
            children={
              <Persona
                {...examplePersona}
                text=" "
                size={PersonaSize.size32}
                presence={PersonaPresence.online}
                hidePersonaDetails={false}
                imageAlt="online"
              />
            }
          /> */}
        </div>
      </div>
    </div>
  );
};

const theme = getTheme();

const navHeader = mergeStyles([
  {
    height: "48px",
    lineHeight: "48px",
    backgroundColor: theme.palette.themePrimary,
    color: theme.palette.white,
    width: "100%",
    display: "flex",
    // overflow: "hidden",
    // position: "fixed",
    top: 0,
  },
  AnimationClassNames.scaleUpIn100,
]);

const navHeaderLeft = mergeStyles([
  {
    padding: "0px",
    margin: "0px",
  },
  AnimationClassNames.scaleUpIn100,
]);

const navHeaderCenter = mergeStyles([
  {
    padding: "0px",
    margin: "0px",
    flex: "1 0 auto",
    fontWeight: "bold",
    displayName: "xLarge",
  },
]);

const navHeaderRight = mergeStyles([
  {
    padding: "0px",
    margin: "0px",
    flex: "0 0 auto",
    alignItems: "center",
    textAlign: "center",
    display: "flex",
  },
]);

const btnClass = mergeStyles([
  {
    height: "48px",
    width: "48px",
    minWidth: "48px",
  },
]);

export default Navbar;
